import {translation} from "@2d-front-monorepo/core";
import {JSX, memo, useMemo} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {Attachments} from "../Attachments";
import {IntegraHolderData} from "../types/IntegraHolderData";
import {ResidencyResult} from "../types/ResidencyResult";
import {Zones} from "../Zones";
import AttachmentsComponent from "./AttachmentsComponent";
import ExpiredAttachmentsComponent from "./ExpiredAttachmentsComponent";

export type ResidencyComponentProps = {
	residency: ResidencyResult;
	holder:IntegraHolderData;
	filesPrefix:string;
}

function ResidencyComponent({residency, holder, filesPrefix}: ResidencyComponentProps): JSX.Element {
	const zone = Zones.get(holder, residency.zoneId);
	const address = residency.address;
	const expired = useMemo(()=> Attachments.findExpired(residency), [residency]);

	return (
		<div className="card card--residency">
			<div className="columns gap padded">
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.residency__street_number)}</dt>
					<dd>{address.streetNumber}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.residency__street)}</dt>
					<dd>{address.street}</dd>
				</dl>
				{address.unit?.unit && <dl className="title-desc col25">
                    <dt>{translation(PermitTranslations.residency__unit)}</dt>
                    <dd>{address.unit?.unit}</dd>
                </dl>}
				{residency.suffix && <dl className="title-desc col25">
                    <dt>{translation(PermitTranslations.residency__suffix)}</dt>
                    <dd>{residency.suffix}</dd>
                </dl>}
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.residency__postal_code)}</dt>
					<dd>{address.postalCode}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.residency__city)}</dt>
					<dd>{address.city}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.residency__state)}</dt>
					<dd>{address.state}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.zone)}</dt>
					<dd>{zone!.name || zone!.id}</dd>
				</dl>
				<AttachmentsComponent entity={residency} linkPrefix={filesPrefix} className="col100"/>
				<ExpiredAttachmentsComponent attachments={expired} linkPrefix={filesPrefix} className="col100"/>
			</div>
		</div>
	);
}

const MemoizedResidencyComponent: React.FC<ResidencyComponentProps> = memo(ResidencyComponent);
export default MemoizedResidencyComponent;
